import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { appForPath } from "./homeScreenApps";

// Safari only re-reads a manifest when the <link> element itself is replaced,
// so swap the node rather than mutating href in place.
function setManifest(href) {
  const current = document.querySelector('link[rel="manifest"]');
  if (current && current.getAttribute("href") === href) return;
  const link = document.createElement("link");
  link.rel = "manifest";
  link.href = href;
  if (current) current.replaceWith(link);
  else document.head.appendChild(link);
}

// iOS takes the home screen artwork from apple-touch-icon, not the manifest.
function setAppleTouchIcon(href) {
  const links = document.querySelectorAll('link[rel="apple-touch-icon"]');
  if (links.length === 1 && links[0].getAttribute("href") === href) return;
  links.forEach((link) => link.remove());
  const link = document.createElement("link");
  link.rel = "apple-touch-icon";
  link.setAttribute("sizes", "180x180");
  link.href = href;
  document.head.appendChild(link);
}

// ...and the suggested icon name from this meta tag.
function setAppleTitle(title) {
  let meta = document.querySelector('meta[name="apple-mobile-web-app-title"]');
  if (!meta) {
    meta = document.createElement("meta");
    meta.name = "apple-mobile-web-app-title";
    document.head.appendChild(meta);
  }
  meta.setAttribute("content", title);
}

/*
 * Keeps the install metadata in sync with the current route so that adding
 * the page to the home screen creates a distinct icon that launches straight
 * back to it. Render once inside the router.
 */
export default function PwaManifest() {
  const { pathname } = useLocation();

  useEffect(() => {
    const app = appForPath(pathname);
    setManifest(app.manifest);
    setAppleTouchIcon(app.appleTouchIcon);
    setAppleTitle(app.title);
  }, [pathname]);

  return null;
}
